<template>
  <div class="products-design-view">
    <CRow class="mb-4">
      <h2>{{this.file_name}}</h2>
    </CRow>
    <CRow class="mb-4">
      <CCol class="col-1">
        <label class="required">Design Name</label>
      </CCol>
      <CCol class="col-3">
        <label class="required">Front design (.svg)</label>
      </CCol>
      <CCol class="col-3">
        <label class="required">Back design (.svg)</label>
      </CCol>
      <CCol class="col-2">
        <label class="required">Select Merchant</label>
      </CCol>
      <CCol class="col-2">
        <label class="required">Select Design Category</label>
      </CCol>
      <CCol class="col-1">
        <label class="required">Actions</label>
      </CCol>
    </CRow>
    <b-alert v-if="file_designs.length < 1" show variant="info">There is no product designs in this file</b-alert>

    <div v-else v-for="(file,design_name) in this.file_designs" :key="file.id">

      <CRow class="mb-4"  >
        <CCol class="col-1" >
          <h5 style="padding-left: 20px">{{design_name}}</h5>
        </CCol>
        <CCol :class="isReversibleDesign(file) ? 'col-2' : 'col-3'" >
          <div class="image-holder">
            <img width="200" height="150" style="max-width:100%;height:auto" :src="base_url+'/'+file['front'].file_url" alt="Front"
                 :style="file['front'].front_product_count>0?'background:gray':'inherit'" />
          </div>
        </CCol>
        <CCol :class="isReversibleDesign(file) ? 'col-2' : 'col-3'" >
          <div class="image-holder">
            <img v-if="file['back']" width="200" height="150" style="max-width:100%;height:auto" :src="base_url+'/'+file['back'].file_url" alt="Back"
                 :style="file['back'].back_product_count>0?'background:gray':'inherit'" />
          </div>
        </CCol>
        <!-- Reversible designs (AB#19680): the production atlas carries every
             panel of BOTH faces, so it is the only view that shows the full
             inside artwork. Rendered only when the parts carry -in suffixes. -->
        <CCol v-if="isReversibleDesign(file)" class="col-2" >
          <div class="image-holder">
            <img v-if="file['production']" width="200" height="150" style="max-width:100%;height:auto"
                 :src="base_url+'/'+file['production'].file_url" alt="Inside + Outside (production)"
                 title="Production atlas — outside and inside panels" />
          </div>
        </CCol>
        <CCol class="col-2">
          <v-select
            placeholder="Select Company" 
            :multiple="true" 
            :options="companies" 
            label="company_name" 
            v-model="file['front'].companies" 
            :searchable="true"
            :closeOnSelect="false"
            @close="assignCompanyToDesignFile(file['front'].id, file['front'].companies)"
            :reduce="company => company.id"
            @option:deselected="assignCompanyToDesignFile(file['front'].id, file['front'].companies)"
          />
        </CCol>
        <CCol class="col-2">
          <v-select
            placeholder="Select Design Category"
            :multiple="true" 
            :closeOnSelect="false" 
            :options="designCategories" 
            label="category_name" 
            track-by="id" 
            v-model="file['front'].design_categories" 
            @close="assignCategoryToDesignFile(file['front'].id, file['front'].design_categories)" 
            @option:deselected="assignCategoryToDesignFile(file['front'].id, file['front'].design_categories)"/>
        </CCol>
        <CCol class="col-1">
         <delete @click="deleteFileDesign(
             file['front'].container_id,
             file['front'].file_id,
             design_name,
             file['front'].front_product_count
             )" class="mr-2" fillColor="#009FE3" />
        </CCol>
      </CRow>
    </div>

  </div>
</template>

<script>
import Delete from 'vue-material-design-icons/TrashCan.vue';
import { http } from "@/config/httpCommon";

export default {
  data(){
    return{
      file_name:'',
      file_designs:[],
      base_url : process.env.VUE_APP_FILE_URL,
      designCategories: [],
      selectedDesignCategories: [],
      companies: [],
      selectedCompanyIds: []
    }

  },
  components: {
     Delete
  },
  created() {
    this.getFileDesigns();
    this.$store.dispatch('getDesignCategories').then((res) => {
      this.designCategories = res.data.result.data;
    });
    this.fetchCompanies();
  },
  methods:{
    // Reversible designs (AB#19680) are recognized by the -in face suffix on
    // their parsed parts (designer master-file standard); only those get the
    // extra production-atlas thumbnail. svg_parts may arrive as JSON string.
    isReversibleDesign(file) {
      const production = file && file['production'];
      let parts = production && production.svg_parts;
      if (!parts) return false;
      if (typeof parts === 'string') {
        try { parts = JSON.parse(parts); } catch (e) { return false; }
      }
      return Array.isArray(parts) && parts.some(p => typeof p === 'string' && /-in$/i.test(p));
    },
    async getFileDesigns(){
      try {
        let file_id = this.$route.params.id;
        this.$store.commit('set', ['showLoader', true]);
        let res = await this.$store.dispatch('getFileDesigns',file_id);
        this.$store.commit('set', ['showLoader', false]);
        this.file_name = res.data.file_name;
        this.file_designs = res.data.file_designs;
      }catch (err){
        this.$store.commit('set', ['showLoader', false]);
        this.showError(err);
      }
    },
    deleteFileDesign(container_id,file_id,design_name,used_count){
      try {

        let confirm_text = `Are you sure to delete ${design_name} design`;
        if(used_count > 0){
          confirm_text = `This design already assigned to products.
          If you delete this design product it will be unassigned to all products.
           Are you sure to delete ${design_name} design`;
        }

        this.$confirm(confirm_text).then(async ()=>{
          this.$store.commit('set', ['showLoader', true]);
          await this.$store.dispatch('deleteFileDesigns',{container_id,file_id,design_name});
          this.$store.commit('set', ['showLoader', false]);
          this.getFileDesigns();
        }).catch(e => {
          console.log(e);
        })
      }catch (err){
        this.$store.commit('set', ['showLoader', false]);
        this.showError(err);
      }
    },
    async assignCategoryToDesignFile(design_file_id, designCategories) {
      this.$store.commit('set', ['showLoader', true]);
      
      let payload = {
        assignments: [
          {
            design_file_id: design_file_id,
            design_category_ids: designCategories.map((category) => category.id)
          }
        ]
      }
      
      await this.$store.dispatch('assignCategoryToDesignFile', payload);
      this.getFileDesigns();
      this.$store.commit('set', ['showLoader', false]);
      this.showToast('Categories assigned to design file successfully', 'SUCCESS');
    },

    async fetchCompanies() {
      let url = `get-companies`;
      try {
        let res = await http.get(url);
        this.companies = res.data.result
      } catch (error) {
        this.showError(error);
      }
    },

    async assignCompanyToDesignFile(design_file_id, companies) {
      if (!design_file_id) return
      try {
        const response = await http.post('container/assign-company-to-design-file', {
          design_file_id,
          company_ids: companies,
        });
        const message = response?.data?.message;
        this.showToast(message, 'SUCCESS');
      } catch (err) {
        const response = err.response; 
        if(response?.status == 422){
          this.showToast(response?.data?.message, 'ERROR');
        } else {
          this.showToast('Something went wrong!', 'ERROR');
        }
      }
    }

  }
}
</script>

<style scoped>
  .products-design-view label{
    font-weight: 600;
    font-size: 1.2rem;
  }
</style>
